export interface IFilterSheetsState {
    isOpen: boolean;
    filtersMap?: Map<string, any>;
}

export interface IFilterTagProps {
    filterKey: string;
    filterValue: string;
}

export interface IFilterSelectProps {
    selectOptions: any;
}

export interface IFilterInputProps {
    inputInfo: any;
}

export interface IFilterDateRangeProps {
    dateRangeInfo: any;
}

export interface IFilterInputRange {
    inputRangeInfo: any;
}

export interface IFiltersProps {
    filters: Array<any>;
    resetButton?: boolean;
}

export const statusOptions = [
    {
        label: "Open",
        value: "OPEN",
    },
    {
        label: "Active",
        value: "ACTIVE",
    },
    {
        label: "Closed",
        value: "CLOSED",
    },
    {
        label: "Overdue",
        value: "OVERDUE",
    },
    {
        label: "Unread",
        value: "UNREAD",
    },
    {
        label: "Succeeded",
        value: "SUCCEEDED",
    },
    {
        label: "Error",
        value: "FAILED",
    },
    {
        label: "Partially Succeeded",
        value: "PARTIALLY_SUCCEEDED",
    },
];

export const assignedToOptions = [
    { label: "Brandon Wright ", value: "branwrit" },
    { label: "Erin O’Neal ", value: "eoneal" },
    { label: "Ryan Simpson ", value: "jryansim" },
    { label: "James Poliyanskiy ", value: "jampol" },
    { label: "Norie Kim ", value: "noriekim" },
    { label: "Rich Macht ", value: "rwmacht" },
    { label: "Sari Fukano ", value: "sariko" },
    { label: "Golda Vanchipurakel ", value: "vangolda" },
    { label: "Joseph Lo ", value: "loljo" },
    { label: "Matt Dlugos ", value: "mwdlugos" },
    { label: "Shweta Goud ", value: "shwegoud" },
    { label: "Ellie El-Emam ", value: "alaaemam" },
    { label: "Nick Clampit ", value: "nclampit" },
    { label: "Seung Son ", value: "seungson" },
    { label: "Charan Yarramsetti ", value: "ysrichar" },
    { label: "Martika Gonzalez ", value: "camartik" },
    { label: "Sam Yin", value: "yinsaman" },
    { label: "Scott Eckhardt ", value: "eckhscot" },
    { label: "Shantanu Mittal", value: "mittshan" },
    { label: "Bosena Telila", value: "telilbof" },
    { label: "Simran Kaur", value: "simrankr" },
    { label: "Anant Kumar", value: "anantmk" },
];

export const stateOptions = [
    { label: "Alabama", value: "Alabama" },
    { label: "Alaska", value: "Alaska" },
    { label: "Arizona", value: "Arizona" },
    { label: "Arkansas", value: "Arkansas" },
    { label: "California", value: "California" },
    { label: "Colorado", value: "Colorado" },
    { label: "Connecticut", value: "Connecticut" },
    { label: "Delaware", value: "Delaware" },
    { label: "Florida", value: "Florida" },
    { label: "Georgia", value: "Georgia" },
    { label: "Hawaii", value: "Hawaii" },
    { label: "Idaho", value: "Idaho" },
    { label: "Illinois", value: "Illinois" },
    { label: "Indiana", value: "Indiana" },
    { label: "Iowa", value: "Iowa" },
    { label: "Kansas", value: "Kansas" },
    { label: "Kentucky", value: "Kentucky" },
    { label: "Louisiana", value: "Louisiana" },
    { label: "Maine", value: "Maine" },
    { label: "Maryland", value: "Maryland" },
    { label: "Massachusetts", value: "Massachusetts" },
    { label: "Michigan", value: "Michigan" },
    { label: "Minnesota", value: "Minnesota" },
    { label: "Mississippi", value: "Mississippi" },
    { label: "Missouri", value: "Missouri" },
    { label: "Montana", value: "Montana" },
    { label: "Nebraska", value: "Nebraska" },
    { label: "Nevada", value: "Nevada" },
    { label: "New Hampshire", value: "New Hampshire" },
    { label: "New Jersey", value: "New Jersey" },
    { label: "New Mexico", value: "New Mexico" },
    { label: "New York", value: "New York" },
    { label: "North Carolina", value: "North Carolina" },
    { label: "North Dakota", value: "North Dakota" },
    { label: "Ohio", value: "Ohio" },
    { label: "Oklahoma", value: "Oklahoma" },
    { label: "Oregon", value: "Oregon" },
    { label: "Pennsylvania", value: "Pennsylvania" },
    { label: "Rhode Island", value: "Rhode Island" },
    { label: "South Carolina", value: "South Carolina" },
    { label: "South Dakota", value: "South Dakota" },
    { label: "Tennessee", value: "Tennessee" },
    { label: "Texas", value: "Texas" },
    { label: "Utah", value: "Utah" },
    { label: "Vermont", value: "Vermont" },
    { label: "Virginia", value: "Virginia" },
    { label: "Washington", value: "Washington" },
    { label: "West Virginia", value: "West Virginia" },
    { label: "Wisconsin", value: "Wisconsin" },
    { label: "Wyoming", value: "Wyoming" },
];
export const jurisdictionOptions = [
    { label: "Anne Arundel", value: "Anne Arundel" },
    { label: "Baltimore", value: "Baltimore" },
    { label: "Bullitt", value: "Bullitt" },
    { label: "Los Angeles", value: "Los Angeles" },
    { label: "San Francisco", value: "San Francisco" },
    { label: "Orange", value: "Orange" },
    { label: "New Haven", value: "New Haven" },
    { label: "Hartford", value: "Hartford" },
    { label: "San Diego", value: "San Diego" },
    { label: "Hampton City", value: "Hampton City" },
    { label: "Sacramento", value: "Sacramento" },
    { label: "Middlesex", value: "Middlesex" },
    { label: "Spokane", value: "Spokane" },
    { label: "Miami-Dade", value: "Miami-Dade" },
    { label: "Lee", value: "Lee" },
    { label: "Arlington", value: "Arlington" },
    { label: "Tarrant", value: "Tarrant" },
    { label: "Worcester", value: "Worcester" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Clark", value: "Clark" },
    { label: "Essex", value: "Essex" },
    { label: "Douglas", value: "Douglas" },
    { label: "Milwaukee", value: "Milwaukee" },
    { label: "Falls Church City", value: "Falls Church City" },
    { label: "District Of Columbia", value: "District Of Columbia" },
    { label: "Washtenaw", value: "Washtenaw" },
    { label: "New Hanover", value: "New Hanover" },
    { label: "Riverside", value: "Riverside" },
    { label: "Duval", value: "Duval" },
    { label: "Chesapeake City", value: "Chesapeake City" },
    { label: "Cumberland", value: "Cumberland" },
    { label: "Hillsborough", value: "Hillsborough" },
    { label: "Broward", value: "Broward" },
    { label: "Dona Ana", value: "Dona Ana" },
    { label: "Muscogee", value: "Muscogee" },
    { label: "El Paso", value: "El Paso" },
    { label: "Tulsa", value: "Tulsa" },
    { label: "Bristol City", value: "Bristol City" },
    { label: "Carroll", value: "Carroll" },
    { label: "Warren", value: "Warren" },
    { label: "Smith", value: "Smith" },
    { label: "Prince George's", value: "Prince George's" },
    { label: "Alameda", value: "Alameda" },
    { label: "Marin", value: "Marin" },
    { label: "Palm Beach", value: "Palm Beach" },
    { label: "San Bernardino", value: "San Bernardino" },
    { label: "Davis", value: "Davis" },
    { label: "King", value: "King" },
    { label: "Lake", value: "Lake" },
    { label: "Fairfax", value: "Fairfax" },
    { label: "Cobb", value: "Cobb" },
    { label: "Maricopa", value: "Maricopa" },
    { label: "Tucker", value: "Tucker" },
    { label: "Benton", value: "Benton" },
    { label: "Kanawha", value: "Kanawha" },
    { label: "Missoula", value: "Missoula" },
    { label: "Hinds", value: "Hinds" },
    { label: "Hidalgo", value: "Hidalgo" },
    { label: "Harris", value: "Harris" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Carroll", value: "Carroll" },
    { label: "Howard", value: "Howard" },
    { label: "Baltimore City", value: "Baltimore City" },
    { label: "Harford", value: "Harford" },
    { label: "Cecil", value: "Cecil" },
    { label: "Frederick", value: "Frederick" },
    { label: "Washington", value: "Washington" },
    { label: "Charles", value: "Charles" },
    { label: "Wicomico", value: "Wicomico" },
    { label: "Somerset", value: "Somerset" },
    { label: "St. Mary's", value: "St. Mary's" },
    { label: "Allegany", value: "Allegany" },
    { label: "Calvert", value: "Calvert" },
    { label: "Iosco", value: "Iosco" },
    { label: "Shelby", value: "Shelby" },
    { label: "Dane", value: "Dane" },
    { label: "Denton", value: "Denton" },
    { label: "Fairfield", value: "Fairfield" },
    { label: "Virginia Beach City", value: "Virginia Beach City" },
    { label: "Hanover", value: "Hanover" },
    { label: "Loudoun", value: "Loudoun" },
    { label: "Santa Clara", value: "Santa Clara" },
    { label: "Louisa", value: "Louisa" },
    { label: "Fayette", value: "Fayette" },
    { label: "Licking", value: "Licking" },
    { label: "St. Charles", value: "St. Charles" },
    { label: "Hampshire", value: "Hampshire" },
    { label: "Beaufort", value: "Beaufort" },
    { label: "Wake", value: "Wake" },
    { label: "Suffolk", value: "Suffolk" },
    { label: "New London", value: "New London" },
    { label: "Providence", value: "Providence" },
    { label: "Gallatin", value: "Gallatin" },
    { label: "Richland", value: "Richland" },
    { label: "Davidson", value: "Davidson" },
    { label: "Augusta", value: "Augusta" },
    { label: "Chatham", value: "Chatham" },
    { label: "Salt Lake", value: "Salt Lake" },
    { label: "Berkeley", value: "Berkeley" },
    { label: "Wilson", value: "Wilson" },
    { label: "Plymouth", value: "Plymouth" },
    { label: "Norfolk", value: "Norfolk" },
    { label: "Gallatin", value: "Gallatin" },
    { label: "Greenville", value: "Greenville" },
    { label: "King William", value: "King William" },
    { label: "Yolo", value: "Yolo" },
    { label: "San Mateo", value: "San Mateo" },
    { label: "Taos", value: "Taos" },
    { label: "Forrest", value: "Forrest" },
    { label: "Manatee", value: "Manatee" },
    { label: "Scott", value: "Scott" },
    { label: "Multnomah", value: "Multnomah" },
    { label: "Santa Barbara", value: "Santa Barbara" },
    { label: "East Baton Rouge", value: "East Baton Rouge" },
    { label: "Fulton", value: "Fulton" },
    { label: "Cumberland", value: "Cumberland" },
    { label: "St. Charles", value: "St. Charles" },
    { label: "Oconee", value: "Oconee" },
    { label: "Aiken", value: "Aiken" },
    { label: "Queen Anne's", value: "Queen Anne's" },
    { label: "Dallas", value: "Dallas" },
    { label: "Tippecanoe", value: "Tippecanoe" },
    { label: "Bedford", value: "Bedford" },
    { label: "Whitfield", value: "Whitfield" },
    { label: "Mecklenburg", value: "Mecklenburg" },
    { label: "Jackson", value: "Jackson" },
    { label: "Dorchester", value: "Dorchester" },
    { label: "Brevard", value: "Brevard" },
    { label: "Prince William", value: "Prince William" },
    { label: "York", value: "York" },
    { label: "Suffolk City", value: "Suffolk City" },
    { label: "Oakland", value: "Oakland" },
    { label: "DeSoto", value: "DeSoto" },
    { label: "Bexar", value: "Bexar" },
    { label: "Orange", value: "Orange" },
    { label: "Collin", value: "Collin" },
    { label: "San Luis Obispo", value: "San Luis Obispo" },
    { label: "Taylor", value: "Taylor" },
    { label: "Fort Bend", value: "Fort Bend" },
    { label: "Kenosha", value: "Kenosha" },
    { label: "Jasper", value: "Jasper" },
    { label: "Shelby", value: "Shelby" },
    { label: "Beaver", value: "Beaver" },
    { label: "Travis", value: "Travis" },
    { label: "Lexington", value: "Lexington" },
    { label: "Horry", value: "Horry" },
    { label: "Tuscola", value: "Tuscola" },
    { label: "Hampton", value: "Hampton" },
    { label: "King George", value: "King George" },
    { label: "Santa Cruz", value: "Santa Cruz" },
    { label: "Henderson", value: "Henderson" },
    { label: "Lubbock", value: "Lubbock" },
    { label: "Taylor", value: "Taylor" },
    { label: "Racine", value: "Racine" },
    { label: "Cherokee", value: "Cherokee" },
    { label: "Marshall", value: "Marshall" },
    { label: "Pickens", value: "Pickens" },
    { label: "Wayne", value: "Wayne" },
    { label: "Catawba", value: "Catawba" },
    { label: "Spartanburg", value: "Spartanburg" },
    { label: "Charleston", value: "Charleston" },
    { label: "Comal", value: "Comal" },
    { label: "Placer", value: "Placer" },
    { label: "Johnson", value: "Johnson" },
    { label: "Boone", value: "Boone" },
    { label: "Jefferson", value: "Jefferson" },
    { label: "Greenwood", value: "Greenwood" },
    { label: "Sarpy", value: "Sarpy" },
    { label: "Bristol", value: "Bristol" },
    { label: "Will", value: "Will" },
    { label: "San Joaquin", value: "San Joaquin" },
    { label: "Middlesex", value: "Middlesex" },
    { label: "Stanislaus", value: "Stanislaus" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Garfield", value: "Garfield" },
    { label: "Franklin", value: "Franklin" },
    { label: "Cook", value: "Cook" },
    { label: "El Paso", value: "El Paso" },
    { label: "Utah", value: "Utah" },
    { label: "Clackamas", value: "Clackamas" },
    { label: "Umatilla", value: "Umatilla" },
    { label: "Morrow", value: "Morrow" },
    { label: "Fauquier", value: "Fauquier" },
    { label: "Pulaski", value: "Pulaski" },
    { label: "Jefferson", value: "Jefferson" },
    { label: "Contra Costa", value: "Contra Costa" },
    { label: "Durham", value: "Durham" },
    { label: "Bartow", value: "Bartow" },
    { label: "Rock", value: "Rock" },
    { label: "Skagit", value: "Skagit" },
    { label: "Cuyahoga", value: "Cuyahoga" },
    { label: "Iredell", value: "Iredell" },
    { label: "Guadalupe", value: "Guadalupe" },
    { label: "Bernalillo", value: "Bernalillo" },
    { label: "Lenoir", value: "Lenoir" },
    { label: "Pinellas", value: "Pinellas" },
    { label: "Washoe", value: "Washoe" },
    { label: "Alachua", value: "Alachua" },
    { label: "Snohomish", value: "Snohomish" },
    { label: "Benton", value: "Benton" },
    { label: "St. Lucie", value: "St. Lucie" },
    { label: "Hays", value: "Hays" },
    { label: "Weld", value: "Weld" },
    { label: "Windham", value: "Windham" },
    { label: "Alamance", value: "Alamance" },
    { label: "Gratiot", value: "Gratiot" },
    { label: "Los Alamos", value: "Los Alamos" },
    { label: "Effingham", value: "Effingham" },
    { label: "Ventura", value: "Ventura" },
    { label: "Norfolk City", value: "Norfolk City" },
    { label: "Lane", value: "Lane" },
    { label: "Canyon", value: "Canyon" },
    { label: "Oklahoma", value: "Oklahoma" },
    { label: "Nevada", value: "Nevada" },
    { label: "Lancaster", value: "Lancaster" },
    { label: "St. Louis", value: "St. Louis" },
    { label: "Boulder", value: "Boulder" },
    { label: "Henrico", value: "Henrico" },
    { label: "Adams", value: "Adams" },
    { label: "Kaufman", value: "Kaufman" },
    { label: "Pierce", value: "Pierce" },
    { label: "Vanderburgh", value: "Vanderburgh" },
    { label: "Cape Girardeau", value: "Cape Girardeau" },
    { label: "Denver", value: "Denver" },
    { label: "Grand Forks", value: "Grand Forks" },
    { label: "San Benito", value: "San Benito" },
    { label: "Richmond", value: "Richmond" },
    { label: "Waukesha", value: "Waukesha" },
    { label: "Anderson", value: "Anderson" },
    { label: "Chesterfield", value: "Chesterfield" },
    { label: "Kern", value: "Kern" },
    { label: "Arapahoe", value: "Arapahoe" },
    { label: "Hampden", value: "Hampden" },
    { label: "Guilford", value: "Guilford" },
    { label: "McLennan", value: "McLennan" },
    { label: "Marion", value: "Marion" },
    { label: "Caddo", value: "Caddo" },
    { label: "Richmond", value: "Richmond" },
    { label: "Blount", value: "Blount" },
    { label: "Johnson", value: "Johnson" },
    { label: "Brazos", value: "Brazos" },
    { label: "Gwinnett", value: "Gwinnett" },
    { label: "Ottawa", value: "Ottawa" },
    { label: "Douglas", value: "Douglas" },
    { label: "Kenton", value: "Kenton" },
    { label: "Brown", value: "Brown" },
    { label: "Delaware", value: "Delaware" },
    { label: "Hendricks", value: "Hendricks" },
    { label: "Polk", value: "Polk" },
    { label: "Stafford", value: "Stafford" },
    { label: "Shenandoah", value: "Shenandoah" },
    { label: "Ada", value: "Ada" },
    { label: "Walton", value: "Walton" },
    { label: "Marshall", value: "Marshall" },
    { label: "St. Tammany", value: "St. Tammany" },
    { label: "Clark", value: "Clark" },
    { label: "Eau Claire", value: "Eau Claire" },
    { label: "Mobile", value: "Mobile" },
    { label: "Kershaw", value: "Kershaw" },
    { label: "Kent", value: "Kent" },
    { label: "Baldwin", value: "Baldwin" },
    { label: "Santa Fe", value: "Santa Fe" },
    { label: "Rutherford", value: "Rutherford" },
    { label: "Culpeper", value: "Culpeper" },
    { label: "Johnston", value: "Johnston" },
    { label: "Saint Louis City", value: "Saint Louis City" },
    { label: "Lake", value: "Lake" },
    { label: "Honolulu", value: "Honolulu" },
    { label: "Kay", value: "Kay" },
    { label: "Calhoun", value: "Calhoun" },
    { label: "Pike", value: "Pike" },
    { label: "Madison", value: "Madison" },
    { label: "Solano", value: "Solano" },
    { label: "Clayton", value: "Clayton" },
    { label: "Washington", value: "Washington" },
    { label: "Columbia", value: "Columbia" },
    { label: "Craven", value: "Craven" },
    { label: "Madison", value: "Madison" },
    { label: "Porter", value: "Porter" },
    { label: "Knox", value: "Knox" },
    { label: "Florence", value: "Florence" },
    { label: "Bradley", value: "Bradley" },
    { label: "Isabella", value: "Isabella" },
    { label: "Sonoma", value: "Sonoma" },
    { label: "Clay", value: "Clay" },
    { label: "Macomb", value: "Macomb" },
    { label: "Fresno", value: "Fresno" },
    { label: "Butte", value: "Butte" },
    { label: "Jackson", value: "Jackson" },
    { label: "Volusia", value: "Volusia" },
    { label: "Summit", value: "Summit" },
    { label: "Bartholomew", value: "Bartholomew" },
    { label: "Delaware", value: "Delaware" },
    { label: "Galveston", value: "Galveston" },
    { label: "Kane", value: "Kane" },
    { label: "Henry", value: "Henry" },
    { label: "Wilson", value: "Wilson" },
    { label: "Leon", value: "Leon" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Waynesboro City", value: "Waynesboro City" },
    { label: "Wood", value: "Wood" },
    { label: "Pasco", value: "Pasco" },
    { label: "Summit", value: "Summit" },
    { label: "Cassia", value: "Cassia" },
    { label: "Coweta", value: "Coweta" },
    { label: "El Dorado", value: "El Dorado" },
    { label: "Waller", value: "Waller" },
    { label: "Limestone", value: "Limestone" },
    { label: "Kent", value: "Kent" },
    { label: "Greene", value: "Greene" },
    { label: "Napa", value: "Napa" },
    { label: "Campbell", value: "Campbell" },
    { label: "Houston", value: "Houston" },
    { label: "Jasper", value: "Jasper" },
    { label: "La Crosse", value: "La Crosse" },
    { label: "Newton", value: "Newton" },
    { label: "Madison", value: "Madison" },
    { label: "Ector", value: "Ector" },
    { label: "Williamson", value: "Williamson" },
    { label: "Marion", value: "Marion" },
    { label: "DeKalb", value: "DeKalb" },
    { label: "West Baton Rouge", value: "West Baton Rouge" },
    { label: "Marion", value: "Marion" },
    { label: "Macon", value: "Macon" },
    { label: "Saginaw", value: "Saginaw" },
    { label: "Pima", value: "Pima" },
    { label: "Thurston", value: "Thurston" },
    { label: "Sheboygan", value: "Sheboygan" },
    { label: "Douglas", value: "Douglas" },
    { label: "Monterey", value: "Monterey" },
    { label: "Laramie", value: "Laramie" },
    { label: "Dale", value: "Dale" },
    { label: "Merced", value: "Merced" },
    { label: "Kings", value: "Kings" },
    { label: "St. Joseph", value: "St. Joseph" },
    { label: "Jackson", value: "Jackson" },
    { label: "Winnebago", value: "Winnebago" },
    { label: "Lafayette", value: "Lafayette" },
    { label: "Sanilac", value: "Sanilac" },
    { label: "Parker", value: "Parker" },
    { label: "Payne", value: "Payne" },
    { label: "Bonneville", value: "Bonneville" },
    { label: "Pottawattamie", value: "Pottawattamie" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Broomfield", value: "Broomfield" },
    { label: "Warren", value: "Warren" },
    { label: "Henderson", value: "Henderson" },
    { label: "Platte", value: "Platte" },
    { label: "Lincoln", value: "Lincoln" },
    { label: "Tolland", value: "Tolland" },
    { label: "Richmond City", value: "Richmond City" },
    { label: "Cabarrus", value: "Cabarrus" },
    { label: "Hall", value: "Hall" },
    { label: "Randall", value: "Randall" },
    { label: "New York", value: "New York" },
    { label: "Whitman", value: "Whitman" },
    { label: "Boone", value: "Boone" },
    { label: "Monroe", value: "Monroe" },
    { label: "McCulloch", value: "McCulloch" },
    { label: "Hamilton", value: "Hamilton" },
    { label: "Douglas", value: "Douglas" },
    { label: "Hancock", value: "Hancock" },
    { label: "Harrison", value: "Harrison" },
    { label: "Genesee", value: "Genesee" },
    { label: "Larimer", value: "Larimer" },
    { label: "George", value: "George" },
    { label: "Williamson", value: "Williamson" },
    { label: "Lancaster", value: "Lancaster" },
    { label: "Ellis", value: "Ellis" },
    { label: "Floyd", value: "Floyd" },
    { label: "Coconino", value: "Coconino" },
    { label: "Marion", value: "Marion" },
    { label: "Sumter", value: "Sumter" },
    { label: "Grant", value: "Grant" },
    { label: "Daviess", value: "Daviess" },
    { label: "Polk", value: "Polk" },
    { label: "Orange", value: "Orange" },
    { label: "Cabell", value: "Cabell" },
    { label: "Dinwiddie", value: "Dinwiddie" },
    { label: "Jefferson", value: "Jefferson" },
    { label: "Chambers", value: "Chambers" },
    { label: "Dougherty", value: "Dougherty" },
    { label: "Pinal", value: "Pinal" },
    { label: "Otero", value: "Otero" },
    { label: "Gaston", value: "Gaston" },
    { label: "Santa Rosa", value: "Santa Rosa" },
    { label: "Mecklenburg", value: "Mecklenburg" },
    { label: "Bergen", value: "Bergen" },
    { label: "Storey", value: "Storey" },
    { label: "Carson City", value: "Carson City" },
    { label: "Winnebago", value: "Winnebago" },
    { label: "Jackson", value: "Jackson" },
    { label: "Forsyth", value: "Forsyth" },
    { label: "Deschutes", value: "Deschutes" },
    { label: "Anchorage", value: "Anchorage" },
    { label: "Eaton", value: "Eaton" },
    { label: "Outagamie", value: "Outagamie" },
    { label: "Onondaga", value: "Onondaga" },
    { label: "Wyandotte", value: "Wyandotte" },
    { label: "Glenn", value: "Glenn" },
    { label: "Prince George", value: "Prince George" },
    { label: "Bibb", value: "Bibb" },
    { label: "Marathon", value: "Marathon" },
    { label: "Ingham", value: "Ingham" },
    { label: "Benton", value: "Benton" },
    { label: "Boone", value: "Boone" },
    { label: "Kitsap", value: "Kitsap" },
    { label: "Philadelphia", value: "Philadelphia" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Cleveland", value: "Cleveland" },
    { label: "Sarasota", value: "Sarasota" },
    { label: "Huron", value: "Huron" },
    { label: "Tulare", value: "Tulare" },
    { label: "Erie", value: "Erie" },
    { label: "Champaign", value: "Champaign" },
    { label: "Union", value: "Union" },
    { label: "Allen", value: "Allen" },
    { label: "Collier", value: "Collier" },
    { label: "Escambia", value: "Escambia" },
    { label: "Clark", value: "Clark" },
    { label: "Hall", value: "Hall" },
    { label: "Laurens", value: "Laurens" },
    { label: "Spotsylvania", value: "Spotsylvania" },
    { label: "Nueces", value: "Nueces" },
    { label: "Bryan", value: "Bryan" },
    { label: "Yavapai", value: "Yavapai" },
    { label: "Hernando", value: "Hernando" },
    { label: "Gilliam", value: "Gilliam" },
    { label: "Valencia", value: "Valencia" },
    { label: "Davidson", value: "Davidson" },
    { label: "Madera", value: "Madera" },
    { label: "Elkhart", value: "Elkhart" },
    { label: "St. Croix", value: "St. Croix" },
    { label: "Franklin", value: "Franklin" },
    { label: "Caroline", value: "Caroline" },
    { label: "Rockwall", value: "Rockwall" },
    { label: "North Slope", value: "North Slope" },
    { label: "Frederick", value: "Frederick" },
    { label: "Johnson", value: "Johnson" },
    { label: "Vermillion", value: "Vermillion" },
    { label: "Linn", value: "Linn" },
    { label: "Pitt", value: "Pitt" },
    { label: "Clark", value: "Clark" },
    { label: "Cowlitz", value: "Cowlitz" },
    { label: "Lewis", value: "Lewis" },
    { label: "Yakima", value: "Yakima" },
    { label: "Kittitas", value: "Kittitas" },
    { label: "Jefferson", value: "Jefferson" },
    { label: "Morgan", value: "Morgan" },
    { label: "Weber", value: "Weber" },
    { label: "Carbon", value: "Carbon" },
    { label: "Elmore", value: "Elmore" },
    { label: "Box Elder", value: "Box Elder" },
    { label: "Malheur", value: "Malheur" },
    { label: "Union", value: "Union" },
    { label: "Albany", value: "Albany" },
    { label: "Baker", value: "Baker" },
    { label: "Lincoln", value: "Lincoln" },
    { label: "Minidoka", value: "Minidoka" },
    { label: "Gooding", value: "Gooding" },
    { label: "Uinta", value: "Uinta" },
    { label: "Sweetwater", value: "Sweetwater" },
    { label: "Rich", value: "Rich" },
    { label: "Robertson", value: "Robertson" },
    { label: "Rowan", value: "Rowan" },
    { label: "St. Francis", value: "St. Francis" },
    { label: "St. Helena", value: "St. Helena" },
    { label: "St. Landry", value: "St. Landry" },
    { label: "Saline", value: "Saline" },
    { label: "Shasta", value: "Shasta" },
    { label: "Simpson", value: "Simpson" },
    { label: "Siskiyou", value: "Siskiyou" },
    { label: "Sumner", value: "Sumner" },
    { label: "Tallapoosa", value: "Tallapoosa" },
    { label: "Tehama", value: "Tehama" },
    { label: "Tippah", value: "Tippah" },
    { label: "Titus", value: "Titus" },
    { label: "Van Zandt", value: "Van Zandt" },
    { label: "Vance", value: "Vance" },
    { label: "Walthall", value: "Walthall" },
    { label: "Warren", value: "Warren" },
    { label: "Warren", value: "Warren" },
    { label: "Wayne", value: "Wayne" },
    { label: "West Feliciana", value: "West Feliciana" },
    { label: "Wood", value: "Wood" },
    { label: "Alcorn", value: "Alcorn" },
    { label: "Alexandria City", value: "Alexandria City" },
    { label: "Allen", value: "Allen" },
    { label: "Amite", value: "Amite" },
    { label: "Autauga", value: "Autauga" },
    { label: "Barrow", value: "Barrow" },
    { label: "Beauregard", value: "Beauregard" },
    { label: "Benton", value: "Benton" },
    { label: "Bowie", value: "Bowie" },
    { label: "Breckinridge", value: "Breckinridge" },
    { label: "Brunswick", value: "Brunswick" },
    { label: "Butler", value: "Butler" },
    { label: "Calcasieu", value: "Calcasieu" },
    { label: "Camp", value: "Camp" },
    { label: "Cass", value: "Cass" },
    { label: "Chilton", value: "Chilton" },
    { label: "Choctaw", value: "Choctaw" },
    { label: "Clark", value: "Clark" },
    { label: "Clarke", value: "Clarke" },
    { label: "Clarke", value: "Clarke" },
    { label: "Cleveland", value: "Cleveland" },
    { label: "Colusa", value: "Colusa" },
    { label: "Coosa", value: "Coosa" },
    { label: "Covington", value: "Covington" },
    { label: "Crittenden", value: "Crittenden" },
    { label: "Dallas", value: "Dallas" },
    { label: "Dearborn", value: "Dearborn" },
    { label: "East Feliciana", value: "East Feliciana" },
    { label: "Edmonson", value: "Edmonson" },
    { label: "Elbert", value: "Elbert" },
    { label: "Evangeline", value: "Evangeline" },
    { label: "Franklin", value: "Franklin" },
    { label: "Freestone", value: "Freestone" },
    { label: "Grayson", value: "Grayson" },
    { label: "Grimes", value: "Grimes" },
    { label: "Hardin", value: "Hardin" },
    { label: "Hardin", value: "Hardin" },
    { label: "Hart", value: "Hart" },
    { label: "Heard", value: "Heard" },
    { label: "Hempstead", value: "Hempstead" },
    { label: "Hot Spring", value: "Hot Spring" },
    { label: "Jasper", value: "Jasper" },
    { label: "Jasper", value: "Jasper" },
    { label: "Jefferson", value: "Jefferson" },
    { label: "Jefferson Davis", value: "Jefferson Davis" },
    { label: "Jones", value: "Jones" },
    { label: "Klamath", value: "Klamath" },
    { label: "Lawrence", value: "Lawrence" },
    { label: "Leon", value: "Leon" },
    { label: "Liberty", value: "Liberty" },
    { label: "Lonoke", value: "Lonoke" },
    { label: "Madison", value: "Madison" },
    { label: "Madison", value: "Madison" },
    { label: "Manassas City", value: "Manassas City" },
    { label: "Marengo", value: "Marengo" },
    { label: "Marion", value: "Marion" },
    { label: "Maury", value: "Maury" },
    { label: "Meade", value: "Meade" },
    { label: "Miller", value: "Miller" },
    { label: "Modoc", value: "Modoc" },
    { label: "Monroe", value: "Monroe" },
    { label: "Morris", value: "Morris" },
    { label: "Navarro", value: "Navarro" },
    { label: "Nevada", value: "Nevada" },
    { label: "Newton", value: "Newton" },
    { label: "Orange", value: "Orange" },
    { label: "Perry", value: "Perry" },
    { label: "Pike", value: "Pike" },
    { label: "Pointe Coupee", value: "Pointe Coupee" },
    { label: "Prairie", value: "Prairie" },
    { label: "Randolph", value: "Randolph" },
    { label: "Ripley", value: "Ripley" },
    { label: "Kit Carson", value: "Kit Carson" },
    { label: "Lincoln", value: "Lincoln" },
    { label: "Washington", value: "Washington" },
    { label: "Bay", value: "Bay" },
    { label: "Calhoun", value: "Calhoun" },
    { label: "Gadsden", value: "Gadsden" },
    { label: "Liberty", value: "Liberty" },
    { label: "Okaloosa", value: "Okaloosa" },
    { label: "Walton", value: "Walton" },
    { label: "Washington", value: "Washington" },
    { label: "Calhoun", value: "Calhoun" },
    { label: "Decatur", value: "Decatur" },
    { label: "Early", value: "Early" },
    { label: "Lamar", value: "Lamar" },
    { label: "Lee", value: "Lee" },
    { label: "Macon", value: "Macon" },
    { label: "Miller", value: "Miller" },
    { label: "Monroe", value: "Monroe" },
    { label: "Peach", value: "Peach" },
    { label: "Spalding", value: "Spalding" },
    { label: "Sumter", value: "Sumter" },
    { label: "Acadia", value: "Acadia" },
    { label: "Ascension", value: "Ascension" },
    { label: "Iberville", value: "Iberville" },
    { label: "Jefferson Davis", value: "Jefferson Davis" },
    { label: "Orleans", value: "Orleans" },
    { label: "St. James", value: "St. James" },
    { label: "St. John the Baptist", value: "St. John the Baptist" },
    { label: "St. Martin", value: "St. Martin" },
    { label: "Hancock", value: "Hancock" },
    { label: "Jackson", value: "Jackson" },
    { label: "Harrison", value: "Harrison" },
    { label: "Orange", value: "Orange" },
    { label: "Jefferson", value: "Jefferson" },
    { label: "Houston County", value: "Houston County" },
    { label: "Calgary", value: "Calgary" },
    { label: "City of Calgary", value: "City of Calgary" },
    { label: "Leduc County", value: "Leduc County" },
    { label: "Parkland", value: "Parkland" },
    { label: "Rocky View", value: "Rocky View" },
    { label: "Maricopa", value: "Maricopa" },
    { label: "Navajo County", value: "Navajo County" },
    { label: "Garland County", value: "Garland County" },
    { label: "British Columbia", value: "British Columbia" },
    { label: "Burrard", value: "Burrard" },
    { label: "Vancouver", value: "Vancouver" },
    { label: "Los Angeles County", value: "Los Angeles County" },
    { label: "Orange County", value: "Orange County" },
    { label: "Riverside County", value: "Riverside County" },
    { label: "San Benito County", value: "San Benito County" },
    { label: "San Bernardino County", value: "San Bernardino County" },
    { label: "San Diego County", value: "San Diego County" },
    { label: "San Mateo County", value: "San Mateo County" },
    { label: "Mesa County", value: "Mesa County" },
    { label: "Bristol", value: "Bristol" },
    { label: "Cromwell", value: "Cromwell" },
    { label: "Naugatuck", value: "Naugatuck" },
    { label: "North Haven", value: "North Haven" },
    { label: "Orange County", value: "Orange County" },
    { label: "Town of Monroe", value: "Town of Monroe" },
    { label: "Town of Windsor", value: "Town of Windsor" },
    { label: "Trumbull", value: "Trumbull" },
    { label: "Wallingford", value: "Wallingford" },
    { label: "Windsor", value: "Windsor" },
    { label: "New Castle", value: "New Castle" },
    { label: "New Castle County", value: "New Castle County" },
    { label: "Brevard County", value: "Brevard County" },
    { label: "Duval County", value: "Duval County" },
    { label: "Duval", value: "Duval" },
    { label: "Leon County", value: "Leon County" },
    { label: "Polk County", value: "Polk County" },
    { label: "St Lucie", value: "St Lucie" },
    { label: "Bartow County", value: "Bartow County" },
    { label: "Bibb County", value: "Bibb County" },
    { label: "Butts County", value: "Butts County" },
    { label: "Dekalb County", value: "Dekalb County" },
    { label: "Forsyth County", value: "Forsyth County" },
    { label: "Ada County", value: "Ada County" },
    { label: "Dekalb", value: "Dekalb" },
    { label: "DuPage", value: "DuPage" },
    { label: "DuPage County", value: "DuPage County" },
    { label: "Lake", value: "Lake" },
    { label: "Lake County", value: "Lake County" },
    { label: "Madison", value: "Madison" },
    { label: "Harrison County", value: "Harrison County" },
    { label: "Johnson", value: "Johnson" },
    { label: "Scott", value: "Scott" },
    { label: "Sedgwick", value: "Sedgwick" },
    { label: "McCracken County", value: "McCracken County" },
    { label: "Caddo Parish", value: "Caddo Parish" },
    { label: "East Baton Rouge Parish", value: "East Baton Rouge Parish" },
    { label: "Jefferson Parish", value: "Jefferson Parish" },
    { label: "Lafayette Parish", value: "Lafayette Parish" },
    { label: "PARISH OF OUACHITA", value: "PARISH OF OUACHITA" },
    { label: "Rapides Parish", value: "Rapides Parish" },
    { label: "Manitoba", value: "Manitoba" },
    { label: "Baltimore County", value: "Baltimore County" },
    { label: "Prince George", value: "Prince George" },
    { label: "Prince George's County", value: "Prince George's County" },
    { label: "City of Boston", value: "City of Boston" },
    { label: "City of Peabody", value: "City of Peabody" },
    { label: "City of Taunton", value: "City of Taunton" },
    { label: "Fall River City", value: "Fall River City" },
    { label: "Town of Milford", value: "Town of Milford" },
    { label: "Town of North Andover", value: "Town of North Andover" },
    { label: "Town of North Reading", value: "Town of North Reading" },
    { label: "Town of Northborough", value: "Town of Northborough" },
    { label: "Town of Westborough", value: "Town of Westborough" },
    { label: "City of Kent", value: "City of Kent" },
    { label: "Easton", value: "Easton" },
    { label: "Gaines Township", value: "Gaines Township" },
    { label: "Grand Traverse County", value: "Grand Traverse County" },
    { label: "Otsego County", value: "Otsego County" },
    { label: "Anoka", value: "Anoka" },
    { label: "Dakota", value: "Dakota" },
    { label: "Hennepin", value: "Hennepin" },
    { label: "Ramsey County", value: "Ramsey County" },
    { label: "Scott", value: "Scott" },
    { label: "St. Louis County", value: "St. Louis County" },
    { label: "Washington", value: "Washington" },
    { label: "Greene or Christian", value: "Greene or Christian" },
    { label: "Sarpy County", value: "Sarpy County" },
    { label: "Clark County", value: "Clark County" },
    { label: "Atlantic", value: "Atlantic" },
    { label: "Burlington", value: "Burlington" },
    { label: "Essex", value: "Essex" },
    { label: "Gloucester", value: "Gloucester" },
    { label: "Glouchester", value: "Glouchester" },
    { label: "Hudson County", value: "Hudson County" },
    { label: "Mercer", value: "Mercer" },
    { label: "Middlesex", value: "Middlesex" },
    { label: "Monmouth", value: "Monmouth" },
    { label: "Passaic County", value: "Passaic County" },
    { label: "Salem", value: "Salem" },
    { label: "Somerset", value: "Somerset" },
    { label: "Township of Mahwah", value: "Township of Mahwah" },
    { label: "Union", value: "Union" },
    { label: "San Juan County", value: "San Juan County" },
    { label: "Valencia County", value: "Valencia County" },
    { label: "Bronx", value: "Bronx" },
    { label: "Dutchess", value: "Dutchess" },
    { label: "Monroe", value: "Monroe" },
    { label: "Nassau", value: "Nassau" },
    { label: "New York City", value: "New York City" },
    { label: "Niagara", value: "Niagara" },
    { label: "Onondaga County", value: "Onondaga County" },
    { label: "Rensselaer", value: "Rensselaer" },
    { label: "Richmond", value: "Richmond" },
    { label: "Suffolk", value: "Suffolk" },
    { label: "Town of Tonawanda (Erie County)", value: "Town of Tonawanda (Erie County)" },
    { label: "Westchester", value: "Westchester" },
    { label: "Cabarrus County", value: "Cabarrus County" },
    { label: "Gaston County", value: "Gaston County" },
    { label: "Pender", value: "Pender" },
    { label: "Wake County", value: "Wake County" },
    { label: "Cass", value: "Cass" },
    { label: "Halifax", value: "Halifax" },
    { label: "Butler", value: "Butler" },
    { label: "Clinton", value: "Clinton" },
    { label: "Cuyahoga County", value: "Cuyahoga County" },
    { label: "Hamilton", value: "Hamilton" },
    { label: "Lucas", value: "Lucas" },
    { label: "Montgomery", value: "Montgomery" },
    { label: "Pickaway", value: "Pickaway" },
    { label: "Pickaway County", value: "Pickaway County" },
    { label: "Stark", value: "Stark" },
    { label: "Warren", value: "Warren" },
    { label: "Brampton", value: "Brampton" },
    { label: "Caledon", value: "Caledon" },
    { label: "Hamilton", value: "Hamilton" },
    { label: "Milton", value: "Milton" },
    { label: "Mississauga", value: "Mississauga" },
    { label: "Ontario", value: "Ontario" },
    { label: "Ontario - Southwold Township", value: "Ontario - Southwold Township" },
    { label: "Ottawa", value: "Ottawa" },
    { label: "Pickering", value: "Pickering" },
    { label: "TOWN OF CALEDON", value: "TOWN OF CALEDON" },
    { label: "Toronto", value: "Toronto" },
    { label: "Vaughan", value: "Vaughan" },
    { label: "Whitby", value: "Whitby" },
    { label: "Windsor", value: "Windsor" },
    { label: "Umatilla County", value: "Umatilla County" },
    { label: "Allegheny", value: "Allegheny" },
    { label: "Berks", value: "Berks" },
    { label: "Bucks", value: "Bucks" },
    { label: "Cumberland", value: "Cumberland" },
    { label: "Dauphin", value: "Dauphin" },
    { label: "Erie", value: "Erie" },
    { label: "Franklin County", value: "Franklin County" },
    { label: "Lackawanna", value: "Lackawanna" },
    { label: "Blacksnake County", value: "Blacksnake County" },
    { label: "Lancaster", value: "Lancaster" },
    { label: "Lehigh", value: "Lehigh" },
    { label: "Luzerne", value: "Luzerne" },
    { label: "Luzerne County", value: "Luzerne County" },
    { label: "Northampton", value: "Northampton" },
    { label: "Schuylkill County", value: "Schuylkill County" },
    { label: "Westmoreland County", value: "Westmoreland County" },
    { label: "York", value: "York" },
    { label: "Borough Lachine", value: "Borough Lachine" },
    { label: "City of Montreal", value: "City of Montreal" },
    { label: "Lava", value: "Lava" },
    { label: "Laval", value: "Laval" },
    { label: "Longueuil", value: "Longueuil" },
    { label: "Quebec", value: "Quebec" },
    { label: "Town of Johnston", value: "Town of Johnston" },
    { label: "Minnehaha", value: "Minnehaha" },
    { label: "Pennington County", value: "Pennington County" },
    { label: "TBD", value: "TBD" },
    { label: "Bexar County", value: "Bexar County" },
    { label: "Dallas and Tarrant", value: "Dallas and Tarrant" },
    { label: "Hill County", value: "Hill County" },
    { label: "Potter", value: "Potter" },
    { label: "Travis County", value: "Travis County" },
    { label: "Williamson County", value: "Williamson County" },
    { label: "Utah County", value: "Utah County" },
    { label: "Arlington County", value: "Arlington County" },
    { label: "Caroline County", value: "Caroline County" },
    { label: "Chesapeake", value: "Chesapeake" },
    { label: "City of Fredericksburg", value: "City of Fredericksburg" },
    { label: "City of Hampton", value: "City of Hampton" },
    { label: "City of Manassas", value: "City of Manassas" },
    { label: "City of Roanoke", value: "City of Roanoke" },
    { label: "City of Virginia Beach", value: "City of Virginia Beach" },
    { label: "Fairfax County", value: "Fairfax County" },
    { label: "Hampton", value: "Hampton" },
    { label: "Loudoun County", value: "Loudoun County" },
    { label: "Louisa County", value: "Louisa County" },
    { label: "Prince William County", value: "Prince William County" },
    { label: "Spotsylvania County", value: "Spotsylvania County" },
    { label: "Stafford County", value: "Stafford County" },
    { label: "Suffolk", value: "Suffolk" },
    { label: "Douglas County", value: "Douglas County" },
    { label: "Franklin County", value: "Franklin County" },
    { label: "King County", value: "King County" },
];

export const fileTypeOptions = [
    { label: "PDF", value: "pdf" },
    { label: "CSV", value: "csv" },
];

export const dataTypeOptions = [
    { label: "Rentals", value: "Rentals" },
    { label: "Sales", value: "Sales" },
];

export const allFilters = {
    keyword: {
        type: "INPUT",
        label: "Search Query",
        inputType: "text",
        keyValue: "mailId",
    },
    mailId: {
        type: "INPUT",
        label: "Mail Id",
        inputType: "text",
        keyValue: "mailId",
        placeholder: "Type in a mail id",
    },
    accountNumber: {
        type: "INPUT",
        label: "Account Number",
        inputType: "text",
        keyValue: "accountNumber",
        placeholder: "Type in an account number",
    },
    checkNumber: {
        type: "INPUT",
        label: "Check Number",
        inputType: "number",
        keyValue: "checkNumber",
        placeholder: "Type in a check number",
    },
    parcelNumber: {
        type: "INPUT",
        label: "Parcel Number",
        inputType: "text",
        keyValue: "parcelNumber",
        placeholder: "Type in an parcel number",
    },
    propertyNumber: {
        type: "INPUT",
        label: "Property Number",
        inputType: "text",
        keyValue: "propertyNumber",
        placeholder: "Type in an property number",
    },
    address: {
        type: "INPUT",
        label: "Address",
        inputType: "text",
        keyValue: "address",
        placeholder: "Type in an address",
    },
    state: {
        type: "SELECT_SEARCH",
        label: "State",
        keyValue: "state",
        placeholder: "Select a state",
        options: [...stateOptions],
    },
    jurisdiction: {
        type: "SELECT_SEARCH",
        label: "Jurisdiction",
        keyValue: "jurisdiction",
        placeholder: "Select a jurisdiction",
        options: [...jurisdictionOptions],
    },
    receiveDate: {
        type: "DATE_RANGE",
        label: "Received Date",
        keyValue: "receiveDate",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    updatedOn: {
        type: "DATE_RANGE",
        label: "Last updated on",
        keyValue: "updatedOn",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    dueDate: {
        type: "DATE_RANGE",
        label: "Due Date",
        keyValue: "dueDate",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    assignedDate: {
        type: "DATE_RANGE",
        label: "Assigned Date",
        keyValue: "assignedDate",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    assignedTo: {
        type: "SELECT_SEARCH",
        label: "Assigned To",
        keyValue: "assignedTo",
        placeholder: "Select a assignee",
        options: [...assignedToOptions],
    },
    status: {
        type: "SELECT",
        label: "Status",
        keyValue: "status",
        placeholder: "Select status",
        options: [...statusOptions],
    },
    earliestPaymentDueDate: {
        type: "DATE_RANGE",
        label: "Earliest Payment Due Date",
        keyValue: "earliestPaymentDueDate",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    filingDueDate: {
        type: "DATE_RANGE",
        label: "Filing Due Date",
        keyValue: "filingDueDate",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    appealDeadline: {
        type: "DATE_RANGE",
        label: "Appeal Deadline",
        keyValue: "appealDeadline",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    taxBillEstimate: {
        type: "DATE_RANGE",
        label: "Tax Bill Estimate",
        keyValue: "taxBillEstimate",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    dateOfHearing: {
        type: "DATE_RANGE",
        label: "Date of Hearing",
        keyValue: "dateOfHearing",
        startPlaceHolder: "MM/DD/YYYY",
        endPlaceHolder: "MM/DD/YYYY",
        startLabel: "Start date",
        endLabel: "End date",
    },
    trueAmountDue: {
        type: "INPUT_RANGE",
        label: "True Amount Due",
        keyValue: "trueAmountDue",
        startLabel: "From",
        endLabel: "To",
        startPlaceholder: "0.00",
        endPlaceholder: "0.00",
        startPrefix: "$",
        endPrefix: "$",
    },
    totalTaxesOwed: {
        type: "INPUT_RANGE",
        label: "Total Taxes Owed",
        keyValue: "totalTaxesOwed",
        startLabel: "From",
        endLabel: "To",
        startPlaceholder: "0.00",
        endPlaceholder: "0.00",
        startPrefix: "$",
        endPrefix: "$",
    },
    fileName: {
        type: "INPUT",
        label: "File name",
        inputType: "text",
        keyValue: "fileName",
        placeholder: "Type in a file name",
    },
    fileType: {
        type: "SELECT",
        label: "File type",
        keyValue: "fileType",
        placeholder: "Select a file type",
        options: [...fileTypeOptions],
    },
    dataType: {
        type: "SELECT",
        label: "Type",
        keyValue: "dataType",
        placeholder: "Select a type",
        options: [...dataTypeOptions],
    },
    fileSizeInMB: {
        type: "INPUT_RANGE",
        label: "File size",
        keyValue: "fileSizeInMB",
        startLabel: "From",
        endLabel: "To",
        startPlaceholder: "0.00",
        endPlaceholder: "0.00",
        startPrefix: "MB",
        endPrefix: "MB",
    },
};
